import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import FunctionInput from './components/FunctionInput';
import GraphPlotter from './components/GraphPlotter';
import './App.css';

function App() {
  const [functions, setFunctions] = useState([]);
  const xMin = -10;
  const xMax = 10;
  const yMin = -10;
  const yMax = 10;
  const gridSize = 200;

  const addFunction = (func) => {
    setFunctions([...functions, { ...func, id: Date.now() }]);
  };

  const removeFunction = (id) => {
    setFunctions(functions.filter(f => f.id !== id));
  };

  const LandingView = () => {
    const navigate = useNavigate();

    return (
      <div className="landing-page">
        <div className="landing-hero">
          <div>
            <p className="site-brand">TECHNOPOWERDEV</p>
            <h1>Expression Graphing</h1>
            <p className="landing-copy">
              Explore mathematical functions by graphing their expressions. Add your own functions or use templates to visualize and understand their behavior.
              <br />
              <br />
            </p>
          </div>

          <button className="landing-tile" onClick={() => navigate('/function-graph')}>
            <span className="tile-title">Function Expression Grapher</span>
            <span className="tile-subtitle"></span>
          </button>
        </div>
      </div>
    );
  };

  const GraphView = () => {
    const navigate = useNavigate();

    return (
      <>
        <div className="tool-topbar">
          <button className="back-btn" onClick={() => navigate('/')}>← Home</button>
          <p className="tool-note">TechnopowerDev graphing workspace</p>
        </div>

        <header className="app-header">
          <h1>Math Learning: Function Grapher</h1>
          <p>Graph functions and explore mathematical relationships and transformations</p>
        </header>

        <div className="app-container">
          <aside className="sidebar">
            <div className="section">
              <h2>Add Function</h2>
              <FunctionInput onAddFunction={addFunction} />
            </div>

            <div className="section">
              <div className="section-header">
                <h2>Functions ({functions.length})</h2>
                {functions.length > 0 && (
                  <button
                    className="reset-btn"
                    onClick={() => setFunctions([])}
                    title="Clear all functions"
                  >
                    Reset All
                  </button>
                )}
              </div>
              <div className="functions-list">
                {functions.length === 0 ? (
                  <p className="empty-message">No functions added yet</p>
                ) : (
                  functions.map((func) => (
                    <div key={func.id} className="function-item" style={{ borderLeftColor: func.color }}>
                      <div className="function-info">
                        <strong>f(x) = {func.expression}</strong>
                        <small>{func.label || 'Function'}</small>
                      </div>
                      <button
                        className="remove-btn"
                        onClick={() => removeFunction(func.id)}
                        title="Remove function"
                      >
                        ✕
                      </button>
                    </div>
                  )))
                }
              </div>
            </div>
          </aside>

          <main className="main-content">
            <GraphPlotter
              functions={functions}
              xMin={xMin}
              xMax={xMax}
              yMin={yMin}
              yMax={yMax}
              gridSize={gridSize}
            />
          </main>
        </div>
      </>
    );
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingView />} />
        <Route path="/function-graph" element={<GraphView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
